import script from "./Wallet.vue?vue&type=script&setup=true&lang=js"
export * from "./Wallet.vue?vue&type=script&setup=true&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=3bfd3ab0&lang=sass&scoped=true"

import exportComponent from "/Users/yablonev/Desktop/Yablonev/Coding/GitHub/TON/Highload-UI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bfd3ab0"]])

export default __exports__